import { Injectable } from '@angular/core';
import { SelfConfigModel } from '@libs/shared/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({
  providedIn: 'root',
})
export class SelfConfigRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public read(): Observable<SelfConfigModel | undefined> {
    return this.connector.connect('user', 'selfConfig');
  }
}
